/** Accept only same-origin absolute paths for post-auth navigation. */
export function safeAuthNext(value: string | null | undefined): string {
  return value?.startsWith("/") && !value.startsWith("//") ? value : "/account";
}
